import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div>
      <h1>PrivacyPolicy</h1>
      <p>PrivacyPolicy page content goes here.</p>
    </div>
  );
};

export default PrivacyPolicy;